import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ObjectSchema } from "yup";

import { errors, yupLocalized } from "@ryde/shared";

import { IPriceLevelItem } from "./price-level.models";

export const usePriceLevelItemResolver = ({
  fromValues,
  itemIndex,
}: {
  fromValues: number[];
  itemIndex?: number;
}) => {
  const { t } = useTranslation();

  const priceLevelFormValidationSchema: ObjectSchema<Partial<IPriceLevelItem>> =
    useMemo(() => {
      return yupLocalized.object<Partial<IPriceLevelItem>>().shape({
        from: yupLocalized
          .number()
          .min(0)
          .required()
          .test(
            "fromHasSameValue",
            t(errors.validation.fromHasSameValue),
            (value, ctx) => {
              if (!fromValues.length) {
                return true;
              }

              return !fromValues.includes(value);
            },
          )
          .test(
            "fromHasLowerValue",
            t(errors.validation.fromHasLowerValue),
            (value, ctx) => {
              if (!itemIndex) {
                return true;
              }

              const prevValue = fromValues[itemIndex - 1];

              if (!prevValue) {
                return true;
              }

              return prevValue < value;
            },
          ),
        price: yupLocalized.number().min(0).required(),
      });
    }, [t, fromValues, itemIndex]);

  return { priceLevelFormValidationSchema };
};
